'use strict'

import { getBreakpoint, getAppPlatform } from '@/utils/app/detect'
import { loadScript } from '@/utils/common'
import { getAppConfig } from '@/config/config'

const config = getAppConfig()
const basePath = config.basePath

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    GujAd: any
  }
}

const getAdaSiteType = (isWebView: boolean) => {
  const siteTypeMap: Record<string, string> = {
    xs: 'mobile',
    sm: 'tablet',
    md: 'desktop',
    lg: 'desktop',
  }

  return isWebView && getAppPlatform()
    ? getAppPlatform()
    : siteTypeMap[getBreakpoint()]
      ? siteTypeMap[getBreakpoint()]
      : 'mobile'
}

const getAdaSiteSize = () => {
  const siteSizeMap: Record<string, string> = {
    xs: 'ntv_size_s',
    sm: 'ntv_size_m',
    md: 'ntv_size_l',
    lg: 'ntv_size_xl',
  }
  return siteSizeMap[getBreakpoint()] ? siteSizeMap[getBreakpoint()] : ''
}

const adAllianceLib = ({
  adZone,
  adKeywords,
  pageType,
  isWebView,
}: {
  adZone: string
  adKeywords: Array<string>
  pageType: string
  isWebView: boolean
}) => {
  window.GujAd = window.GujAd || {}
  window.GujAd.cmd = window.GujAd.cmd || []

  const siteType = getAdaSiteType(isWebView)
  const isIndexPage = pageType === 'index'
  const siteSize = getAdaSiteSize()

  window.GujAd.cmd.push(function () {
    window.GujAd.getClient().setSiteType(siteType)
    window.GujAd.getClient().setZone(adZone)
    window.GujAd.getClient().setIsIndexPage(isIndexPage)
    window.GujAd.getClient().setKeywords(adKeywords)
    window.GujAd.getClient().addKeyword(siteSize)
  })

  const adSlots = document.getElementsByClassName('gujAd')

  for (let i = 0; i < adSlots.length; i++) {
    window.GujAd.cmd.push(function () {
      window.GujAd.push(adSlots[i].id)
    })
  }

  window.GujAd.cmd.push(function () {
    window.GujAd.finalizeInlineLoading()
  })

  loadScript(
    window.location.search.indexOf('gujAd=1') > -1
      ? 'https://www.n-tv.de/stat/molten/preview/ntv/MoltenBundle.top.js'
      : `${basePath}/mbundle/top.js`,
  )

  loadScript(
    window.location.search.indexOf('gujAd=1') > -1
      ? 'https://www.n-tv.de/stat/molten/preview/ntv/MoltenBundle.bottom.js'
      : `${basePath}/mbundle/bottom.js`,
  )

  // VCC
  loadScript('https://bilder-a.akamaihd.net/ip/vcc/vcc.min.js?site=ntv')
}

export const pushAd = (adId: string) => {
  if (window.GujAd) {
    window.GujAd.cmd.push(function () {
      window.GujAd.push(adId)
    })
  }
}

export const reloadAds = () => {
  if (window.GujAd) {
    window.GujAd.cmd.push(function () {
      window.GujAd.getClient().reloadAds()
    })
  }
}

export const reloadAd = (adId: string) => {
  if (window.GujAd) {
    window.GujAd.cmd.push(function () {
      window.GujAd.getClient().reloadAd(adId)
    })
  }
}

export default adAllianceLib
